import { render } from "./TriadListModalComponent.vue?vue&type=template&id=3bf30452&scoped=true"
import script from "./TriadListModalComponent.vue?vue&type=script&lang=js"
export * from "./TriadListModalComponent.vue?vue&type=script&lang=js"

import "./TriadListModalComponent.vue?vue&type=style&index=0&id=3bf30452&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf30452"]])

export default __exports__